import { isToday, isYesterday, isThisYear } from 'date-fns';
import { ru } from 'locale';
import formatDate from './formatDate';
import { shortDateFullMonthFormat, shortDateFullMonthFullYearFormat } from './dateFormats';

const getCalendarDate = date => {
  if (isToday(date)) {
    return ru.today;
  }
  if (isYesterday(date)) {
    return ru.yesterday;
  }
  if (isThisYear(date)) {
    return formatDate(date, shortDateFullMonthFormat);
  }

  return formatDate(date, shortDateFullMonthFullYearFormat);
};

export default getCalendarDate;
